<template>
    <div
        id="__layout__content"
        class="flex flex-col min-h-screen"
        :class="{ 'transitions-enabled': $store.state.areCSSAnimationsAllowed }"
    >
        <Header v-if="!$store.state.isWebView" class="z-40" />

        <main class="flex-grow" :class="{ 'pt-18 sm:pt-14': !$store.state.isWebView }">
            <Nuxt class="relative" />
        </main>

        <Footer v-if="!$store.state.isWebView" class="relative lg:z-5" />

        <MainAudioPlayer class="z-20" />

        <GridOverlay />

        <CookieBanner class="z-50" />

        <BaseModal :is-open="isSurveyModalOpen" :close="closeSurveyModal">
            <iframe
                class="h-[calc(90vh-6rem)]"
                src="https://docs.google.com/forms/d/e/1FAIpQLSdeLxrL8gkEpPBFeJouGPgHpXGxQJyj7k34fbVzgSz88BadoQ/viewform?embedded=true"
                width="100%"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
                style="margin: 0 auto"
            ></iframe>
        </BaseModal>
    </div>
</template>

<script>
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
import MainAudioPlayer from '../components/Players/MainAudioPlayer/MainAudioPlayer';
import GridOverlay from '../components/Layout/GridOverlay';
import CookieBanner from '../components/Layout/CookieBanner';
import BaseModal from '../components/Modals/BaseModal';

export default {
    name: 'Default',
    components: {
        Header,
        Footer,
        MainAudioPlayer,
        GridOverlay,
        CookieBanner,
        BaseModal,
    },
    middleware: ['redirects', 'init'],
    data() {
        return {
            isSurveyModalOpen: false,
        };
    },
    mounted() {
        if (this.$store.state.globals.shouldDisplaySurveyModal) {
            this.isSurveyModalOpen = true;
        }
    },
    methods: {
        closeSurveyModal() {
            this.isSurveyModalOpen = false;
        },
    },
};
</script>

<style></style>
